import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { getMetaData, getNotificationState } from 'common/header/notifications/hooks/Notification.utils';
import { NotificationIntlMessages } from 'src/components/common/header/translations/useNotificationsIntl';

export const getSupplierRelationShipChangeTitle = (
  notificationViewModel: Partial<MappedNotification>,
  intl: NotificationIntlMessages
): Partial<MappedNotification> => {
  const metadata = getMetaData(notificationViewModel);
  const state = getNotificationState(notificationViewModel.status);
  const supAccepted = metadata?.find((e) => e?.key === 'STATUS')?.value === 'ACCEPTED';
  let title: string;
  if (state.isError) {
    title = intl.supplierInvitationTitleError;
  } else {
    title = supAccepted ? intl.supplierInvitationTitleAccepted : intl.supplierInvitationTitleDeclined;
  }

  return { title, iconType: supAccepted ? 'INFO' : 'FAILURE' };
};
